import React from "react";
import { NumberInput } from "@jsq/ds/core";
import { createFieldPlaceholder, handleNumberInputWheel } from "./utils";
import type { FieldEditorProps } from "./types";

/**
 * Currency Field Editor Component
 *
 * Specialized input component for currency (USD) extension fields.
 * Provides currency input with proper formatting, validation, and design system styling.
 */
export const CurrencyFieldEditor: React.FC<FieldEditorProps> = ({
  field,
  value,
  onChange,
  error,
  disabled,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onChange(newValue);
  };

  const handleSetValue = (newValue: string) => {
    onChange(newValue);
  };

  return (
    <NumberInput
      value={value}
      onChange={handleChange}
      onSetValue={handleSetValue}
      onWheel={handleNumberInputWheel}
      placeholder={createFieldPlaceholder(field)}
      disabled={disabled}
      errorMessage={error || undefined}
      isFullWidth
      step="0.01"
      min={0}
      preAdornment="$"
      data-testid="currency-field-editor"
    />
  );
};

export default CurrencyFieldEditor;
